module.exports = __webpack_public_path__ + "img/linkedin_white.d5da7ce4.png";